import { createReducer, on } from "@ngrx/store";
import { CourseState, initialCourseState } from "./course.state";
import { GetCategoriesByCourseId, GetCategoriesByCourseIdError, GetCategoriesByCourseIdSuccess, GetCourseById, GetCourseByIdError, GetCourseByIdSuccess, GetCourses, GetCoursesError, GetCoursesSuccess } from "./course.actions";
import { CourseGrouped } from "src/app/_models/CourseGrouped";
import { AppConstants } from "src/app/constants/constants";
import { Course } from "src/app/_models/Course";

export const CourseReducers = createReducer(
  initialCourseState,
  on(GetCourses, (state) => {
    return {
      ...state,
      list: [],
      error: null,
      inUsedCourses: [],
      courseGrouped: [],
      loading: true
    }
  }),
  on(GetCoursesSuccess, (state, action) => {
    return {
      ...state,
      list: action.result,
      inUsedCourses: action.result.filter(c => c.inUsed),
      courseGrouped: [
        {
          GroupName: AppConstants.CURRENT,
          Courses: action.result.filter(c => c.inUsed)
        },
        {
          GroupName: AppConstants.PREVIOUS,
          Courses: action.result.filter(c => !c.inUsed)
        }
      ],
      loading: false
    }
  }),
  on(GetCoursesError, (state, action) => {
    return {
      ...state,
      error: action.error,
      loading: false
    }
  }),
  on(GetCourseById, (state) => {
    return {
      ...state,
      error: null,
      loading: true
    }
  }),
  on(GetCourseByIdSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      course: action.course
    }
  }),
  on(GetCourseByIdError, (state, action) => {
    return {
      ...state,
      error: action.error,
      loading: false
    }
  }),
  on(GetCategoriesByCourseId, (state) => {
    return {
      ...state,
      error: null,
      loading: true
    }
  }),
  on(GetCategoriesByCourseIdSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      courseCategories: action.categories
    }
  }),
  on(GetCategoriesByCourseIdError, (state, action) => {
    return {
      ...state,
      error: action.error,
      loading: false
    }
  })  
)